//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'
import 'devextreme/ui/form'
import 'devextreme/ui/popup'
import 'devextreme/ui/tabs'
import 'devextreme/ui/toolbar'
import 'devextreme/ui/toolbar'
import 'devextreme/ui/scroll_view'

//#endregion

import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { InfoPopupSource } from '../../common/info-popup/info-popup.directive'
import { TabsData } from '../../common/common.interfaces'

import { EventsNames, LocalizationHelper, TemplateHelper, ConfigHelper, IUserSession, TypeHelper } from '../../../helpers'
import { PaymentType } from '../../../helpers/common-helper'
import { Permissions } from '../../../helpers/permissions'

import { Enums } from '../../../models/common'
import { OpCurrency } from '../../../models/core/'
import { OpTask } from '../../../models/core'
import { OpTaskPaymentElement } from '../../../models/custom/'


import { PaymentsBridgeOptions, IPaymentsCreateEdit, PaymentSubmitResult, PaymentGridModel } from './payments.interfaces'


interface PaymentsScope extends ng.IScope {
    source: PaymentsBridgeOptions

    popupOptions: DevExpress.ui.dxPopupOptions
    popupTitle: string
    popupVisible: boolean

    tabs: TabsData
    toolbarOptions: DevExpress.ui.dxToolbarOptions

    isClientCanEdit: boolean
    isFitterCanEdit: boolean

    clientFormOptions: DevExpress.ui.dxFormOptions
    clientSetPaymentFormOptions: DevExpress.ui.dxFormOptions
    clientPaymentsToolbarOptions: DevExpress.ui.dxToolbarOptions

    fitterFormOptions: DevExpress.ui.dxFormOptions
    fitterSetPaymentFormOptions: DevExpress.ui.dxFormOptions
    fitterPaymentsToolbarOptions: DevExpress.ui.dxToolbarOptions

    clientPaymentsGridOptions: GridOptions
    fitterPaymentsGridOptions: GridOptions

    isAddPaymentDisabledFitter: boolean
    isRemovePaymentDisabledFitter: boolean
    isAddPaymentDisabledClient: boolean
    isRemovePaymentDisabledClient: boolean

    isLoading: boolean
    scrollHeight: number | string

    fitterEditAllowed: boolean
    clientEditAllowed: boolean

    infoPopupId: number
    needInfoPopup: boolean
    infoPopupSource: InfoPopupSource
}

export class PaymentsController implements ng.IComponentController, IPaymentsCreateEdit {
    private permissions: any[]
    private tabs: { template: string, name: string }[]
    private paymentTaskId: string

    private fitterGridsItems: PaymentGridModel[] = []
    private clientGridsItems: PaymentGridModel[] = []

    private fitterPaymentsGrid: DevExpress.ui.dxDataGrid
    private clientPaymentsGrid: DevExpress.ui.dxDataGrid
    private selectedRowsFitter: OpTaskPaymentElement[] = []
    private selectedRowsClient: OpTaskPaymentElement[] = []
    private addedPayments: OpTaskPaymentElement[] = []
    private removedPayments: OpTaskPaymentElement[] = []
    private clientFreePaymentsSelectBox: DevExpress.ui.dxSelectBox
    private fitterFreePaymentsSelectBox: DevExpress.ui.dxSelectBox
    private clientSetPaymentForm: DevExpress.ui.dxForm
    private fitterSetPaymentForm: DevExpress.ui.dxForm
    private clientSetPaymentAmount: DevExpress.ui.dxNumberBox
    private fitterSetPaymentAmount: DevExpress.ui.dxNumberBox
    private clientSetPaymentNotes: DevExpress.ui.dxTextArea
    private fitterSetPaymentNotes: DevExpress.ui.dxTextArea
    private clientFormOrdered: DevExpress.ui.dxCheckBox
    private fitterFormOrdered: DevExpress.ui.dxCheckBox
    private clientFormPaid: DevExpress.ui.dxCheckBox
    private fitterFormPaid: DevExpress.ui.dxCheckBox
    private clientFormDate: DevExpress.ui.dxDateBox
    private fitterFormDate: DevExpress.ui.dxDateBox
    private clientFormAmount: DevExpress.ui.dxNumberBox
    private fitterFormAmount: DevExpress.ui.dxNumberBox
    private clientWasOrderedToPay: boolean
    private fitterWasOrderedToPay: boolean
    private submitButton: DevExpress.ui.dxButton
    private paymentsData: OpTaskPaymentElement[]

    constructor(
        private $scope: PaymentsScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private userSession: IUserSession
    ) {
        $scope.infoPopupId = new Date().getTime()
        $scope.tabs = <TabsData>{}
        $scope.isAddPaymentDisabledFitter = true
        $scope.isRemovePaymentDisabledFitter = true
        $scope.isAddPaymentDisabledClient = true
        $scope.isRemovePaymentDisabledClient = true

        $scope.isClientCanEdit = true
        $scope.isFitterCanEdit = true

        $scope.clientEditAllowed = !$scope.source.source.clientOrderedToPay
        $scope.fitterEditAllowed = !$scope.source.source.fitterOrderedToPay

        this.clientWasOrderedToPay = $scope.source.source.clientOrderedToPay
        this.fitterWasOrderedToPay = $scope.source.source.fitterOrderedToPay

        $scope.popupVisible = false


        if (!$scope.tabs.selectedTab) {
            $scope.tabs.selectedTab = 0
        }

        jQuery.when.apply(jQuery,
            [Permissions.TASK_FITTER_PAYMENT_LIST, Permissions.TASK_FITTER_PAYMENT_EDIT, Permissions.TASK_CLIENT_PAYMENT_LIST, Permissions.TASK_CLIENT_PAYMENT_EDIT]
                .map(p => Permissions.hasPermissions([p]))
        ).then((...permissions) => {
            this.permissions = permissions
            this.configureTabs(this.getTabs())
        })

        this.onInitialized()
    }


    // IComponentController Implementation 

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // IComponentController Implementation End

    public onInitialized(): void {
        if (this.$scope.source != null && _.isFunction(this.$scope.source.onInitialized)) {
            this.$scope.source.onInitialized(this)
        }
    }

    public onRefreshRequest(): void {
        if (this.$scope.source != null && _.isFunction(this.$scope.source.onRefreshRequest)) {
            this.$scope.source.onRefreshRequest()
        }
    }

    public open(): void {
        this.initialize()

    }


    private needToShowInfoPopup() {
        this.$scope.needInfoPopup = true
        this.$scope.infoPopupSource = {
            infoText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentWarningMessage),
            popupTitle: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Warning)
        }

        this.$timeout(() => {
            this.$scope.$root.$broadcast(EventsNames.OPEN_INFO_POPUP_POPUP + this.$scope.infoPopupId, [])
        }, 500)
    }


    private initialize(): void {
        this.$scope.isLoading = true

        this.reset()

        this.$scope.popupVisible = true

        if (this.$scope.source.editAllowed != true) {
            this.$scope.isClientCanEdit = false
            this.$scope.isFitterCanEdit = false
            this.$scope.clientEditAllowed = false
            this.$scope.fitterEditAllowed = false
        } else {
            this.$scope.isClientCanEdit = true
            this.$scope.isFitterCanEdit = true
            this.$scope.clientEditAllowed = !this.$scope.source.source.clientOrderedToPay
            this.$scope.fitterEditAllowed = !this.$scope.source.source.fitterOrderedToPay
        }

        this.$timeout(() => {
            if (this.submitButton) this.submitButton.option('disabled', true)
        })

        this.userSession.getDataProvider().Task.getTaskPayments(this.$scope.source.popupId, false).then((result: OpTaskPaymentElement[]) => {
            this.setPopupOptions()
            this.setFormsOptions()
            this.setGridsOptions()
            this.setPaymentsOptions(result)
            this.setToolbarsOptions()

            this.$timeout(() => {
                this.clientWasOrderedToPay = this.$scope.source.source.clientOrderedToPay
                this.fitterWasOrderedToPay = this.$scope.source.source.fitterOrderedToPay
            })

            this.$scope.isLoading = false
        })
    }


    private setPopupOptions(): void {
        this.$scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible',
                title: 'source.popupTitle'
            },
            maxWidth: 800,
            maxHeight: 800,
            showTitle: true,
            closeOnOutsideClick: true,
            onHiding: () => {
                this.$scope.popupVisible = false
                $(window).off("resize");
                if (this.submitButton) this.submitButton.option('disabled', true)
            },
            onShown: (e: any) => {
                this.$scope.scrollHeight = ($('.payments').height() - 95) + 'px'
            }
        }
    }

    private configureTabs = (tabs: { template: string, name: string }[]) => {
        if (this.$scope.tabs.selectedTab >= tabs.length) {
            this.$scope.tabs.selectedTab = tabs.length - 1
        }
        this.tabs = tabs
        this.$scope.tabs.selectedTabName = this.getSelectedTabName()
        this.$scope.tabs.visible = this.tabs.length > 1
        this.$scope.tabs.tabsOptions = {
            dataSource: tabs,
            bindingOptions: {
                selectedIndex: 'tabs.selectedTab',
                visible: 'tabs.visible'
            },
            onSelectionChanged: (e: any) => {
                this.$timeout(() => {
                    this.$scope.tabs.selectedTabName = this.getSelectedTabName()
                }, 100)
                e.component.repaint()
            },
            onInitialized: (e: any) => {
                //tabsPanel = e.component
            }
        }
    }

    private getTabs = () => {
        const [TASK_FITTER_PAYMENT_LIST, TASK_FITTER_PAYMENT_EDIT, TASK_CLIENT_PAYMENT_LIST, TASK_CLIENT_PAYMENT_EDIT] = this.permissions
        const tabs = []
        if (TASK_CLIENT_PAYMENT_EDIT) tabs.push({ template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Client), ConfigHelper.Icon.USER, this.userSession), name: 'client' })
        if (TASK_FITTER_PAYMENT_EDIT) tabs.push({ template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Fitter), ConfigHelper.Icon.USER_OUTLINE, this.userSession), name: 'fitter' })
        return tabs
    }

    private getSelectedTabName = () => {
        return this.tabs[this.$scope.tabs.selectedTab] ? this.tabs[this.$scope.tabs.selectedTab].name : ''
    }

    private setFormsOptions(): void {
        this.$scope.clientFormOptions = {
            formData: this.$scope.source.source,
            items: this.clientFormItems(),
            colCountByScreen: {
                lg: 2,
                md: 2,
                sm: 2,
                xs: 1
            },
            alignItemLabels: true,
            labelLocation: "top",
            onFieldDataChanged: (e: any) => {
                if (this.submitButton) this.submitButton.option('disabled', false)
            },
            bindingOptions: {
                disabled: '!isClientCanEdit'
            }
        }

        this.$scope.fitterFormOptions = {
            formData: this.$scope.source.source,
            items: this.fitterFormItems(),
            colCountByScreen: {
                lg: 2,
                md: 2,
                sm: 2,
                xs: 1
            },
            alignItemLabels: true,
            labelLocation: "top",
            onFieldDataChanged: (e: any) => {
                if (this.submitButton) this.submitButton.option('disabled', false)
            },
            bindingOptions: {
                disabled: '!isFitterCanEdit'
            }
        }
    }

    private setGridsOptions(): void {
        this.clientGridsItems = this.$scope.source.source.payments.filter(item => { return item.paymentType == Enums.TaskPaymentType.Client })
        this.fitterGridsItems = this.$scope.source.source.payments.filter(item => { return item.paymentType == Enums.TaskPaymentType.Fitter })

        const masterDetailExists = (data: any): boolean => {
            return data.notes && data.notes.length > 0
        }

        const columns: any[] = [
            { dataField: "description", caption: LocalizationHelper.getLocalizedText('Product') },
            { dataField: "value", caption: LocalizationHelper.getLocalizedText('Amount'), type: 1 },
            { dataField: "notes", caption: LocalizationHelper.getLocalizedText('Notes'), visible: false }
        ]

        this.$scope.clientPaymentsGridOptions = {
            name: "clientPaymentsGrid",
            type: GridTypes.NO_SEARCH_BAR_SMALL,
            buttonsOptions: {
                enabled: false
            },
            dataSource: new DataSource(this.clientGridsItems),
            addCustomFilters: true,
            columns: columns,
            height: '400px',
            onInitialized: (e: any) => {
                this.clientPaymentsGrid = e.component
            },
            onSelectionChanged: (e: any) => {
                if (this.$scope.source.source.clientOrderedToPay != true) {
                    if (e.selectedRowKeys.length > 0) {
                        this.selectedRowsClient = e.selectedRowKeys
                        this.$scope.isRemovePaymentDisabledClient = false
                    } else {
                        this.$scope.isRemovePaymentDisabledClient = true
                    }
                }
            },
            onRowPrepared: (e: any) => {
                this.markRow(e)
            },

            masterDetailExists,

            masterDetail: {
                enabled: true,
                template: "detail",
                autoExpandAll: true
            },
        }

        this.$scope.fitterPaymentsGridOptions = {
            name: "fitterPaymentsGrid",
            type: GridTypes.NO_SEARCH_BAR_SMALL,
            buttonsOptions: {
                enabled: false
            },
            dataSource: new DataSource(this.fitterGridsItems),
            addCustomFilters: true,
            columns: columns,
            height: '400px',
            onInitialized: (e: any) => {
                this.fitterPaymentsGrid = e.component
            },
            onSelectionChanged: (e: any) => {
                if (this.$scope.source.source.fitterOrderedToPay != true) {
                    if (e.selectedRowKeys.length > 0) {
                        this.selectedRowsFitter = e.selectedRowKeys
                        this.$scope.isRemovePaymentDisabledFitter = false
                    } else {
                        this.$scope.isRemovePaymentDisabledFitter = true
                    }
                }
            },
            onRowPrepared: (e: any) => {
                this.markRow(e)
            },

            masterDetailExists,

            masterDetail: {
                enabled: true,
                template: "detail",
                autoExpandAll: true
            },
        }

        if (this.clientPaymentsGrid)
            this.clientPaymentsGrid.option("dataSource", new DataSource(this.clientGridsItems.map(item => { if (item.isRemoved) { item.isRemoved = false } return item })))
        if (this.fitterPaymentsGrid)
            this.fitterPaymentsGrid.option("dataSource", new DataSource(this.fitterGridsItems.map(item => { if (item.isRemoved) { item.isRemoved = false } return item })))
    }

    private setPaymentsOptions(result: OpTaskPaymentElement[]): void {
        this.paymentsData = result

        this.$scope.fitterSetPaymentFormOptions = {
            formData: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                return item.paymentType == Enums.TaskPaymentType.Fitter
            }),
            items: this.fitterPaymentsFormItems(),
            minColWidth: 350,
            alignItemLabels: true,
            labelLocation: "top",
            onInitialized: (e: any) => {
                this.fitterSetPaymentForm = e.component
            },
            bindingOptions: {
                readOnly: '!isFitterCanEdit'
            }
        }

        this.$scope.fitterPaymentsToolbarOptions = {
            items: [
                {
                    location: 'center',
                    widget: 'dxButton',
                    options: {
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
                        bindingOptions: {
                            disabled: 'isAddPaymentDisabledFitter'
                        },
                        onClick: () => {

                            this.$timeout(() => {
                                this.$scope.isAddPaymentDisabledFitter = true

                                let newPaymentElement: OpTaskPaymentElement = new OpTaskPaymentElement(null)

                                newPaymentElement.description = this.paymentsData.filter((item: OpTaskPaymentElement) => {
                                    return item.description == this.$scope.fitterSetPaymentFormOptions.formData['description'] && item.paymentType == Enums.TaskPaymentType.Fitter
                                })[0].description
                                newPaymentElement.notes = this.$scope.fitterSetPaymentFormOptions.formData['paymentNote']
                                newPaymentElement.value = this.$scope.fitterSetPaymentFormOptions.formData['paymentAmount']
                                newPaymentElement.indexNbr = 0
                                newPaymentElement.paymentType = Enums.TaskPaymentType.Fitter
                                newPaymentElement.opState = Enums.OpChangeState.New,
                                    newPaymentElement.currency = new OpCurrency(null),

                                    this.addPayment(newPaymentElement, true)
                            })
                        }
                    }
                },
                {
                    location: 'center',
                    widget: 'dxButton',
                    options: {
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
                        bindingOptions: {
                            disabled: 'isRemovePaymentDisabledFitter'
                        },
                        onClick: () => {
                            this.removePayment(this.selectedRowsFitter, this.fitterPaymentsGrid, this.$scope.fitterPaymentsGridOptions, PaymentType.Fitter)
                            let amountToRemove: number = 0
                            this.selectedRowsFitter.forEach((item: PaymentGridModel) => {
                                if (item.isRemoved == true) amountToRemove -= item.value
                                else amountToRemove += item.value
                            })
                            this.fitterFormAmount.option('value', this.fitterFormAmount.option('value') + amountToRemove)
                        }
                    }
                }
            ],
            bindingOptions: {
                disabled: '!isFitterCanEdit'
            }
        }

        this.$scope.clientSetPaymentFormOptions = {
            formData: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                return item.paymentType == Enums.TaskPaymentType.Client
            }),
            items: this.clientPaymentsFormItems(),
            minColWidth: 350,
            alignItemLabels: true,
            labelLocation: "top",
            onInitialized: (e: any) => {
                this.clientSetPaymentForm = e.component
            },
            bindingOptions: {
                readOnly: '!isClientCanEdit'
            }
        }

        this.$scope.clientPaymentsToolbarOptions = {
            items: [{
                location: 'center',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Add),
                    bindingOptions: {
                        disabled: 'isAddPaymentDisabledClient'
                    },
                    onClick: () => {
                        this.$timeout(() => {
                            this.$scope.isAddPaymentDisabledClient = true

                            let newPaymentObject: OpTaskPaymentElement = new OpTaskPaymentElement(null)

                            newPaymentObject.description = this.paymentsData.filter((item: OpTaskPaymentElement) => { return item.description == this.$scope.clientSetPaymentFormOptions.formData['description'] && item.paymentType == Enums.TaskPaymentType.Client })[0].description
                            newPaymentObject.notes = this.clientSetPaymentNotes ? this.clientSetPaymentNotes.option('value') : this.$scope.clientSetPaymentFormOptions.formData['paymentNote']
                            newPaymentObject.value = this.clientSetPaymentAmount ? this.clientSetPaymentAmount.option('value') : this.$scope.clientSetPaymentFormOptions.formData['paymentAmount']
                            newPaymentObject.indexNbr = 0
                            newPaymentObject.paymentType = Enums.TaskPaymentType.Client

                            newPaymentObject.opState = Enums.OpChangeState.New
                            newPaymentObject.currency = new OpCurrency(null)

                            this.addPayment(newPaymentObject, true)
                        })
                    }
                }
            }, {
                location: 'center',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Delete),
                    bindingOptions: {
                        disabled: 'isRemovePaymentDisabledClient'
                    },
                    onClick: () => {
                        this.removePayment(this.selectedRowsClient, this.clientPaymentsGrid, this.$scope.clientPaymentsGridOptions, PaymentType.Client)
                        let amountToRemove: number = 0
                        this.selectedRowsClient.forEach((item: PaymentGridModel) => {
                            if (item.isRemoved == true) amountToRemove -= item.value
                            else amountToRemove += item.value
                        })
                        this.clientFormAmount.option('value', this.clientFormAmount.option('value') + amountToRemove)
                    }
                }
            }
            ],
            bindingOptions: {
                disabled: '!isClientCanEdit'
            }
        }
        this.$scope.isLoading = false
    }

    private setToolbarsOptions() {
        this.$scope.toolbarOptions = {
            items: [{
                location: 'after',
                widget: 'dxButton',
                options: {
                    text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
                    disabled: true,
                    onInitialized: (e: any) => {
                        this.submitButton = e.component
                    },
                    onClick: () => {
                        //submit()
                        if (this.$scope.source.onSubmit) {
                            if (this.submitButton) this.submitButton.option('disabled', true)
                            let resultModel = new OpTask(null)
                            resultModel.fitterOrderedToPay = !!(this.fitterFormOrdered ? this.fitterFormOrdered.option('value') : this.$scope.fitterFormOptions.formData['fitterOrderedToPay'])
                            resultModel.paymentAmount = this.fitterFormAmount ? this.fitterFormAmount.option('value') : this.$scope.fitterFormOptions.formData['fitterPaymentAmount']
                            resultModel.fitterPaymentDate = this.fitterFormDate ? this.fitterFormDate.option('value') : this.$scope.fitterFormOptions.formData['fitterPaymentDate']
                            resultModel.fitterPaymentDone = !!(this.fitterFormPaid ? this.fitterFormPaid.option('value') : this.$scope.fitterFormOptions.formData['fitterPaymentDone'])
                            let isFitterPaymentsEdited = true

                            resultModel.clientOrderedToPay = !!(this.clientFormOrdered ? this.clientFormOrdered.option('value') : this.$scope.clientFormOptions.formData['clientOrderedToPay'])
                            resultModel.clientPaymentAmount = this.clientFormAmount ? this.clientFormAmount.option('value') : this.$scope.clientFormOptions.formData['clientPaymentAmount']
                            resultModel.clientPaymentDate = this.clientFormDate ? this.clientFormDate.option('value') : this.$scope.clientFormOptions.formData['clientPaymentDate']
                            resultModel.clientPaymentDone = !!(this.clientFormPaid ? this.clientFormPaid.option('value') : this.$scope.clientFormOptions.formData['clientPaymentDone'])
                            let isClientPaymentsEdited = true

                            let loaded = this.$scope.source.source.payments

                            this.removedPayments.forEach(pay => {
                                loaded = loaded.filter(item => { return item.description != pay.description })
                            })
                            this.addedPayments.forEach(pay => {
                                loaded = loaded.filter(item => { return item.description != pay.description })
                            })
                            const temObj: PaymentSubmitResult = {
                                idTask: this.$scope.source.source.idTask,
                                formData: resultModel,
                                added: this.addedPayments,
                                removed: this.removedPayments,
                                inGrid: loaded,
                                isFitterPaymentsEdited: isFitterPaymentsEdited,
                                isClientPaymentsEdited: isClientPaymentsEdited
                            }

                            this.savePayments(temObj)
                        }
                    }
                }
            }]
        }
    }

    private savePayments = (paymentObj: PaymentSubmitResult) => {
        this.$scope.isLoading = true
        this.$scope.source.onSubmit(paymentObj).then(() => {
            this.$scope.isLoading = false
            this.$scope.popupVisible = false
        }).always(() => {
            this.$scope.isLoading = false
        })
    }

    private clientFormItems() {
        var items: any[] = []
        items.push({
            dataField: "clientOrderedToPay",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.OrderedToPay)
            },
            editorType: "dxCheckBox",
            editorOptions: {
                onInitialized: (e: any) => {
                    this.clientFormOrdered = e.component
                    this.clientFormOrdered.option('readOnly', this.$scope.source.source.clientPaymentDone)
                },
                onValueChanged: (e: any) => {
                    this.$scope.clientEditAllowed = !e.value
                    this.clientFormPaid.option('readOnly', !e.value)
                    if (this.clientWasOrderedToPay == true && e.value == false) this.needToShowInfoPopup()
                }
            }
        })
        if (this.clientFormOrdered) this.clientFormOrdered.option('value', this.$scope.source.source.clientOrderedToPay)
        items.push({
            dataField: "clientPaymentDone",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentDone)
            },
            editorType: "dxCheckBox",
            editorOptions: {
                onInitialized: (e: any) => {
                    this.clientFormPaid = e.component
                    this.clientFormPaid.option('readOnly', !this.$scope.source.source.clientOrderedToPay)
                },
                onValueChanged: (e: any) => {
                    this.clientFormOrdered.option('readOnly', e.value)
                    this.clientFormDate.option('value', new Date())
                }
            }
        })
        if (this.clientFormPaid) this.clientFormPaid.option('value', this.$scope.source.source.clientPaymentDone)
        items.push({
            dataField: "fitterPaymentDate",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Date)
            },
            editorType: "dxDateBox",
            editorOptions: {
                max: new Date(),
                width: '100%',
                onInitialized: (e: any) => {
                    this.clientFormDate = e.component
                },
                readOnly: true
            }
        })
        if (this.clientFormDate) this.clientFormDate.option('value', this.$scope.source.source.clientPaymentDate)
        items.push({
            dataField: "clientPaymentAmount",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentAmount) + ' ' + this.$scope.source.currency
            },
            editorType: "dxNumberBox",
            editorOptions: {
                min: 0,
                onInitialized: (e: any) => {
                    this.clientFormAmount = e.component
                },
                readOnly: true
            }
        })
        if (this.clientFormAmount) this.clientFormAmount.option('value', this.$scope.source.source.clientPaymentAmount)
        return items
    }

    private fitterFormItems() {
        var items: any[] = []
        items.push({
            dataField: "fitterOrderedToPay",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.OrderedToPay)
            },
            editorType: "dxCheckBox",
            editorOptions: {
                onInitialized: (e: any) => {
                    this.fitterFormOrdered = e.component
                    this.fitterFormOrdered.option('readOnly', this.$scope.source.source.fitterPaymentDone)
                },
                onValueChanged: (e: any) => {
                    this.$scope.fitterEditAllowed = !e.value
                    this.fitterFormPaid.option('readOnly', !e.value)
                    if (this.fitterWasOrderedToPay == true && e.value == false) this.needToShowInfoPopup()
                }
            }
        })
        if (this.fitterFormOrdered) this.fitterFormOrdered.option('value', this.$scope.source.source.fitterOrderedToPay)
        items.push({
            dataField: "fitterPaymentDone",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentDone)
            },
            editorType: "dxCheckBox",
            editorOptions: {
                onInitialized: (e: any) => {
                    this.fitterFormPaid = e.component
                    this.fitterFormPaid.option('readOnly', !this.$scope.source.source.fitterOrderedToPay)
                },
                onValueChanged: (e: any) => {
                    this.fitterFormOrdered.option('readOnly', e.value)
                    this.fitterFormDate.option('value', new Date())
                }
            }
        })
        if (this.fitterFormPaid) this.fitterFormPaid.option('value', this.$scope.source.source.fitterPaymentDone)
        items.push({
            dataField: "fitterPaymentDate",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Date)
            },
            editorType: "dxDateBox",
            editorOptions: {
                max: new Date(),
                width: '100%',
                onInitialized: (e: any) => {
                    this.fitterFormDate = e.component
                },
                readOnly: true
            }
        })
        if (this.fitterFormDate) this.fitterFormDate.option('value', this.$scope.source.source.fitterPaymentDate)
        items.push({
            dataField: "paymentAmount",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PaymentAmount) + ' ' + this.$scope.source.currency
            },
            editorType: "dxNumberBox",
            editorOptions: {
                min: 0,
                onInitialized: (e: any) => {
                    this.fitterFormAmount = e.component
                },
                readOnly: true
            }
        })
        if (this.fitterFormAmount) this.fitterFormAmount.option('value', this.$scope.source.source.paymentAmount)
        return items
    }



    private clientPaymentsFormItems() {
        const items: any[] = []
        items.push({
            dataField: "description",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Product)
            },
            editorType: "dxSelectBox",
            editorOptions: {
                dataSource: new ArrayStore({
                    data: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                        return item.paymentType == Enums.TaskPaymentType.Client
                    }),
                    key: "description"
                }),
                displayExpr: "description",
                valueExpr: "description",
                onInitialized: (e: any) => {
                    this.clientFreePaymentsSelectBox = e.component
                },
                onValueChanged: (e: any) => {
                    if (e.value) {
                        const item: OpTaskPaymentElement[] = this.paymentsData.filter((item: OpTaskPaymentElement) => {
                            return item.description == e.value && item.paymentType == Enums.TaskPaymentType.Client
                        })
                        this.$scope.clientSetPaymentFormOptions.formData['paymentAmount'] = item[0].value
                        this.$scope.clientSetPaymentFormOptions.formData['paymentNote'] = item[0].notes
                        this.$scope.clientSetPaymentFormOptions.formData['description'] = item[0].description
                        this.$scope.isAddPaymentDisabledClient = false

                        this.clientSetPaymentAmount.option('value', item[0].value)
                        this.clientSetPaymentNotes.option('value', item[0].notes)
                    }
                },
                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData)
            }
        })
        items.push({
            dataField: "paymentAmount",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount) + ' ' + this.$scope.source.currency
            },
            editorType: "dxNumberBox",
            editorOptions: {
                min: 0,
                showSpinButtons: true,
                onInitialized: (e: any) => {
                    this.clientSetPaymentAmount = e.component
                },
                value: 0,
            }
        })
        items.push({
            dataField: "paymentNote",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes)
            },
            colSpan: 2,
            editorType: "dxTextArea",
            editorOptions: {
                height: 130,
                onInitialized: (e: any) => {
                    this.clientSetPaymentNotes = e.component
                }
            }
        })

        if (this.clientFreePaymentsSelectBox) {
            this.clientFreePaymentsSelectBox.option("dataSource", new ArrayStore({
                data: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                    return item.paymentType == Enums.TaskPaymentType.Client
                }),
                key: "indexNbr"
            }))
        }
        return items
    }

    private fitterPaymentsFormItems() {
        const items: any[] = []
        items.push({
            dataField: "description",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Product)
            },
            editorType: "dxSelectBox",
            editorOptions: {
                dataSource: new ArrayStore({
                    data: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                        return item.paymentType == Enums.TaskPaymentType.Fitter
                    }),
                    key: "indexNbr"
                }),
                displayExpr: "description",
                valueExpr: "description",
                onInitialized: (e: any) => {
                    this.fitterFreePaymentsSelectBox = e.component
                },
                onValueChanged: (e: any) => {
                    if (e.value) {
                        const item: OpTaskPaymentElement[] = this.paymentsData.filter((item: OpTaskPaymentElement) => {
                            return item.description == e.value && item.paymentType == Enums.TaskPaymentType.Fitter
                        })
                        this.$scope.fitterSetPaymentFormOptions.formData['paymentAmount'] = item[0].value
                        this.$scope.fitterSetPaymentFormOptions.formData['paymentNote'] = item[0].notes
                        this.$scope.fitterSetPaymentFormOptions.formData['description'] = item[0].description
                        this.$scope.isAddPaymentDisabledFitter = false

                        this.fitterSetPaymentAmount.option('value', item[0].value)
                        this.fitterSetPaymentNotes.option('value', item[0].notes)
                    }
                },
                placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
                noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData)
            }
        })
        items.push({
            dataField: "paymentAmount",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount) + ' ' + this.$scope.source.currency
            },
            editorType: "dxNumberBox",
            editorOptions: {
                min: 0,
                showSpinButtons: true,
                onInitialized: (e: any) => {
                    this.fitterSetPaymentAmount = e.component
                },
                onValueChanged: (e: any) => {
                    this.$scope.fitterSetPaymentFormOptions.formData['paymentAmount'] = e.value
                },
                value: 0,
            }
        })
        items.push({
            dataField: "paymentNote",
            label: {
                text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes)
            },
            colSpan: 2,
            editorType: "dxTextArea",
            editorOptions: {
                height: 130,
                onInitialized: (e: any) => {
                    this.fitterSetPaymentNotes = e.component
                },
                onValueChanged: (e: any) => {
                    this.$scope.fitterSetPaymentFormOptions.formData['paymentNote'] = e.value
                }
            }
        })
        if (this.fitterFreePaymentsSelectBox) {
            this.fitterFreePaymentsSelectBox.option("dataSource", new ArrayStore({
                data: this.paymentsData.filter((item: OpTaskPaymentElement) => {
                    return item.paymentType == Enums.TaskPaymentType.Fitter
                }),
                key: "indexNbr"
            }))
        }
        return items
    }





    private addPayment(payment: OpTaskPaymentElement, isNew: boolean) {
        if (this.submitButton) this.submitButton.option('disabled', false)
        const check: OpTaskPaymentElement[] = this.addedPayments.filter(item => { return item.description == payment.description && item.indexNbr == payment.indexNbr && item.paymentType == payment.paymentType })
        if (payment.paymentType == Enums.TaskPaymentType.Fitter) {
            this.fitterFreePaymentsSelectBox.getDataSource().store().load().done(items => {
                this.$scope.fitterSetPaymentFormOptions.formData['paymentNote'] = ''
                this.$scope.fitterSetPaymentFormOptions.formData['paymentAmount'] = ''
                this.$scope.fitterSetPaymentFormOptions.formData['description'] = null

                if (this.fitterFreePaymentsSelectBox) this.fitterFreePaymentsSelectBox.reset()
                if (this.fitterSetPaymentAmount) this.fitterSetPaymentAmount.reset()
                if (this.fitterSetPaymentNotes) this.fitterSetPaymentNotes.reset()

                this.$scope.isAddPaymentDisabledFitter = true
                if (check.length == 0) {
                    this.fitterFormAmount.option('value', this.fitterFormAmount.option('value') + payment.value)
                    this.fitterGridsItems.push(payment)
                    this.fitterPaymentsGrid.option("dataSource", new DataSource(this.fitterGridsItems))
                    this.addedPayments.push(payment)

                    items.forEach(p => { //hiding selected product
                        if (p.element == payment.description) p.visible = false
                    })
                    this.fitterFreePaymentsSelectBox.option({
                        dataSource: new ArrayStore({
                            data: items,
                            key: "indexNbr"
                        })
                    })
                }
            })
        }
        if (payment.paymentType == Enums.TaskPaymentType.Client) {
            this.clientFreePaymentsSelectBox.getDataSource().store().load().done(items => {
                this.$scope.clientSetPaymentFormOptions.formData['paymentNote'] = ''
                this.$scope.clientSetPaymentFormOptions.formData['paymentAmount'] = ''
                this.$scope.clientSetPaymentFormOptions.formData['description'] = null

                if (this.clientFreePaymentsSelectBox) {
                    this.clientFreePaymentsSelectBox.reset()
                }

                if (this.clientSetPaymentAmount) {
                    this.clientSetPaymentAmount.reset()
                }

                if (this.clientSetPaymentNotes) {
                    this.clientSetPaymentNotes.reset()
                }

                this.$scope.isAddPaymentDisabledClient = true
                if (check.length == 0) {
                    this.clientFormAmount.option('value', this.clientFormAmount.option('value') + payment.value)
                    this.clientGridsItems.push(payment)
                    this.clientPaymentsGrid.option("dataSource", new DataSource(this.clientGridsItems))
                    this.addedPayments.push(payment)

                    items.forEach(p => { //hiding selected product
                        if (p.element == payment.description) p.visible = false
                    })
                    this.clientFreePaymentsSelectBox.option({
                        dataSource: new ArrayStore({
                            data: items,
                            key: 'indexNbr'
                        })
                    })
                }
            })
        }
    }

    private removePayment = (dataToRemove: PaymentGridModel[], grid: DevExpress.ui.dxDataGrid, gridOptions: GridOptions, paymentType: number) => {
        if (this.submitButton) this.submitButton.option('disabled', false)
        var items: PaymentGridModel[] = []
        if (paymentType == PaymentType.Client)
            items = this.clientGridsItems
        if (paymentType == PaymentType.Fitter)
            items = this.fitterGridsItems
        dataToRemove.forEach(tr => {
            if (!tr.isRemoved) {
                items.forEach(item => {
                    if (item.description == tr.description) {
                        item.isRemoved = true
                        if (!item.isNew)
                            this.removedPayments.push(item)
                        else {
                            this.addedPayments = this.addedPayments.filter(added => { return added.description != item.description })

                            if (paymentType == PaymentType.Client) {
                                this.clientFreePaymentsSelectBox.getDataSource().store().load().done(items => {
                                    items.forEach(p => { //restoring selected product
                                        if (p.element == tr.description) p.visible = true
                                    })
                                    this.clientFreePaymentsSelectBox.option({
                                        dataSource: new ArrayStore({
                                            data: items,
                                            key: "indexNbr"
                                        })
                                    })
                                })
                            }
                            if (paymentType == PaymentType.Fitter) {
                                this.fitterFreePaymentsSelectBox.getDataSource().store().load().done(items => {
                                    items.forEach(p => { //restoring selected product
                                        if (p.element == tr.description) p.visible = true
                                    })
                                    this.fitterFreePaymentsSelectBox.option({
                                        dataSource: new ArrayStore({
                                            data: items,
                                            key: "indexNbr"
                                        })
                                    })
                                })
                            }
                        }
                    }
                })
            } else {
                this.removedPayments = this.removedPayments.filter(item => { return item.description != tr.description })
                items.forEach(item => {
                    if (item.description == tr.description)
                        item.isRemoved = false
                })
            }
        })
        items = items.filter(item => { return (item.isNew == true && item.isRemoved != true) || (item.isNew != true && item.isRemoved == true) || (!item.isNew && !item.isRemoved) })
        if (paymentType == PaymentType.Client)
            this.clientGridsItems = items
        if (paymentType == PaymentType.Fitter)
            this.fitterGridsItems = items
        grid.option("dataSource", new DataSource(items))
    }

    private markRow = (e: any) => {
        if (e.rowType == "data" || e.rowType == "detail") {
            if (e.data.isNew) {
                $(e.rowElement).css('font-style', 'italic')
            }
            else if (e.data.isRemoved) {
                $(e.rowElement).css('text-decoration', 'line-through')
            }
            else if (e.data.isEdited) {
                $(e.rowElement).css('font-weight', 'bold')
            }
            e.rowElement.addClass('myRow').data('keyValue', e.key);
        }
        if (e.rowElement.hasClass('dx-master-detail-row') && (!e.data.notes || e.data.notes == ''))
            e.rowElement.addClass('display-none')
    }


    private reset(): void {

        this.fitterGridsItems = []
        this.clientGridsItems = []
        this.selectedRowsFitter = []
        this.selectedRowsClient = []
        this.addedPayments = []
        this.removedPayments = []

        if (this.clientFreePaymentsSelectBox) {
            this.clientFreePaymentsSelectBox.reset()
        }

        if (this.fitterFreePaymentsSelectBox) {
            this.fitterFreePaymentsSelectBox.reset()
        }

        if (this.clientSetPaymentAmount) {
            this.clientSetPaymentAmount.reset()
        }

        if (this.fitterSetPaymentAmount) {
            this.fitterSetPaymentAmount.reset()
        }

        if (this.clientSetPaymentNotes) {
            this.clientSetPaymentNotes.reset()
        }

        if (this.fitterSetPaymentNotes) {
            this.fitterSetPaymentNotes.reset()
        }
    }
}